"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _elementUi = require("element-ui");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var requestLoading = /*#__PURE__*/function () {
  function requestLoading() {
    _classCallCheck(this, requestLoading);
    _defineProperty(this, "loadObj", null);
    _defineProperty(this, "isEnable", true);
    _defineProperty(this, "reqNum", 0);
  }
  _createClass(requestLoading, [{
    key: "addReqNum",
    value: function addReqNum() {
      this.reqNum += 1;
    }
  }, {
    key: "reduceNum",
    value: function reduceNum() {
      if (this.isEnable) {
        if (this.reqNum > 0) {
          this.reqNum -= 1;
        }
        if (this.reqNum == 0) {
          this.loadObj.close();
        }
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this.loadObj) {
        this.loadObj.close();
      }
    }
  }, {
    key: "open",
    value: function open() {
      if (this.isEnable) {
        this.loadObj = _elementUi.Loading.service({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.addReqNum();
      }
    }
  }]);
  return requestLoading;
}();
var reqLoad = new requestLoading();
var _default = reqLoad;
exports["default"] = _default;